
import { RadioGroup } from '@headlessui/react'
import React from 'react'

export default function ParcelPaymentComponent({ selected, setSelected, items }: any) {

    return (

        <div className="block w-full">
            <div className="mt-2">
                <RadioGroup
                    value={selected}
                    onChange={setSelected}
                    className="md:grid md:grid-cols-2 md:gap-5 auto-rows-auto space-y-4 md:space-y-0"
                >
                    {items?.length > 0 ? (
                        items?.map(
                            (item: any, index: any) =>
                                item.show && (
                                    <RadioGroup.Option
                                        key={index}
                                        value={item.value}
                                        className={({ checked }) =>
                                            `${checked ? ' border-blue-800' : ' border-blue-400'}
                           border-2 relative shadow-md focus:outline-none rounded-md p-5 block cursor-pointer min-h-[112px] h-full group address__box`
                                        }
                                    >
                                        <RadioGroup.Label
                                            as="h3"
                                            className=" font-semibold mb-2 -mt-1"
                                        >
                                            {item?.name}
                                        </RadioGroup.Label>
                                        <RadioGroup.Description
                                            as="div"
                                            className="  leading-6"
                                        >
                                            {item?.description}
                                        </RadioGroup.Description>
                                    </RadioGroup.Option>
                                ),
                        )
                    ) : (
                        <div className="border-2 border-skin-base rounded font-semibold p-5 px-10 text-skin-ouprimary flex justify-start items-center min-h-[112px] h-full">
                            No payment option found
                        </div>
                    )}
                </RadioGroup>
            </div>
        </div>



    )
}